@if (open()) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center p-4"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="title()"
  >
    <div
      class="absolute inset-0 bg-black/50 backdrop-blur-sm"
      (click)="onCancel()"
    ></div>

    <div
      class="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-[0_8px_40px_rgba(0,0,0,0.18)]"
    >
      <h2 class="font-display text-xl text-gray-900">{{ title() }}</h2>
      @if (message()) {
        <p class="mt-2 text-sm leading-6 text-gray-500">{{ message() }}</p>
      }

      <div class="mt-6 flex flex-wrap justify-end gap-2">
        <button type="button" class="btn-outline-gray" (click)="onCancel()">
          {{ cancelLabel() }}
        </button>
        <button
          type="button"
          class="rounded-lg bg-red-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500/40"
          (click)="onConfirm()"
        >
          {{ confirmLabel() }}
        </button>
      </div>
    </div>
  </div>
}
